// Phase 6.C — 작업일정 / 오전 작업 sub-route.
// 시안 design/v3/SchedulePage.jsx SECTIONS[1] (id="morning").

import { AlertBanner, EmptyState } from '../../components/primitives';
import { useViewport } from '../../lib/useViewport';
import { findSection } from './data';
import { SectionCard } from './SectionCard';

export function ScheduleMorningRoute() {
  const isMobile = useViewport() === 'mobile';
  const section = findSection('morning');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <AlertBanner
        tone="info"
        message="오전 작업 — 점심 영업 준비 일정. Phase 7 후 발송 활성."
      />
      {section ? (
        <SectionCard section={section} isMobile={isMobile} />
      ) : (
        <EmptyState
          icon="sun"
          title="등록된 오전 작업이 없습니다"
          description="작업일정은 사장/직원이 직접 등록하는 회사별 격리 영역입니다. Phase 7 backend 도입 후 등록이 활성됩니다."
        />
      )}
    </div>
  );
}
